// Colour helpers shared by tokens.js and look.js (contrast-safe text, mixing).
const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
export function isHex(v) {
    return typeof v === "string" && HEX.test(v.trim());
}
export function rgb(hex) {
    let h = hex.trim().slice(1);
    if (h.length === 3) h = h.split("").map((c) => c + c).join("");
    return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
}
export function luminance(hex) {
    const [r, g, b] = rgb(hex).map((c) => {
        const s = c / 255;
        return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
export function contrast(a, b) {
    const [x, y] = [luminance(a), luminance(b)].sort((m, n) => n - m);
    return (x + 0.05) / (y + 0.05);
}
// Black or white, whichever reads better on `bg`.
export function inkOn(bg, dark = "#111111", light = "#ffffff") {
    if (!isHex(bg)) return light;
    return contrast(bg, dark) >= contrast(bg, light) ? dark : light;
}


const hex2 = (n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, "0");
// `pct` percent of `toward` mixed into `base` (both #hex). Returns #rrggbb.
export function mixHex(base, toward, pct) {
    const a = rgb(base), b = rgb(toward), k = pct / 100;
    return "#" + a.map((c, i) => hex2(c * (1 - k) + b[i] * k)).join("");
}
